import { Label } from '@cloudez/cloudez-design-system';
import React, { InputHTMLAttributes } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { Select } from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  name: string;
  register?: UseFormRegister<any>;
  error?: any;
  background?: boolean;
  block?: boolean;
  options: { value: string | number; title: string }[];
  value?: any;
  onChange?: any;
  disableOption?: boolean;
  disabled?: boolean;
}

export const CustomSelect = ({
  label,
  name,
  register,
  error,
  value,
  block,
  onChange,
  background,
  options,
  disableOption,
  disabled,
}: InputProps) => {
  return (
    <Select block={block} background={background}>
      <Label>{label}</Label>

      {register ? (
        <select disabled={disabled} {...register(name)}>
          {options.map(item => (
            <option value={item.value}>{item.title}</option>
          ))}
        </select>
      ) : (
        <select disabled={disabled} value={value} onChange={onChange}>
          {options.map((item, index) => (
            <option disabled={index === 0 && disableOption} value={item.value}>
              {item.title}
            </option>
          ))}
        </select>
      )}

      {error && <span className="error">{error}</span>}
    </Select>
  );
};
